export const environment = {
  production: false,
  appConfig: {
    apiUrl: 'https://dev-api.onsceneservices.com',
    version: '1.0.10',
  },
};
